export const delayUntilIdle = callback => window.requestIdleCallback ? window.requestIdleCallback(callback, {
  timeout: 5000
}) : window.setTimeout(callback, 0);